<template>
	<div class="bingliComp">
		<div v-if="$public.isNull(diagnosisTags)" style="font-size: 14px;line-height: 140px;text-align: center;color:rgb(247, 138, 29);">请选择病情诊断</div>
		<div class="nav" v-if="!$public.isNull(diagnosisTags)">
			<div v-for="(item,index) in diagnosisTags" :key="index" class="navItem" :class="[curTag===index?'active':'']" @click="changeCurTag(item,index)">
				{{item.value}}
			</div>
		</div>
		<div class="con" v-if="!$public.isNull(diagnosisTags)">
			<!-- <div class="tit">病例记录</div> -->
			<div class="msgBox" v-if="!$public.isNull(detail)">
				<div class="msgLine">
					<div class="msgItem">平均治疗时长{{detail.cureDuration}}天</div>
					<!-- <div class="msgItem">共计{{$public.jia(detail.diedCount,detail.cureCount)}}例</div> -->
					<div class="msgItem">共计{{detail.useCount}}例</div>
				</div>
				<div class="msgLine" >
					<div class="msgItem">治愈{{detail.cureCount}}例，死亡{{detail.diedCount}}例</div>
				</div>
			</div>
			<div class="addLine" v-if="!$public.isNull(detail)">
				<div class="addLineLabel"></div>
				<div class="addAllBtn" @click="add(detail.recipeGoodsList)">一键添加所有药品</div>
			</div>
			<div class="nav1">
				<div class="nav1Item" :class="[curNavIndex===0?'active':'']" @click="changeCurNavIndex(0)">治疗效果最好</div>
				<div class="nav1Item" :class="[curNavIndex===1?'active':'']" @click="changeCurNavIndex(1)">治疗时间最快</div>
				<div class="nav1Item" :class="[curNavIndex===2?'active':'']" @click="changeCurNavIndex(2)">性价比最高</div>
			</div>
			<div class="table">
				<div class="row">
					<div class="tableTit" style="width:120px;">药品信息</div>
					<div class="tableTit" style="width:110px;">出库量</div>
					<div class="tableTit" style="width:120px;">用法</div>
				</div>
				<div v-if="$public.isNull(detail)">
					<div style="font-size: 12px;line-height: 100px;text-align: center;">暂无处方</div>
				</div>
				<div v-else>
					<div v-for="(item,index) in detail.recipeGoodsList" :key="index">
						<div class="row">
							<div class="tableCell" style="width:20px;">
								{{index+1}}.
							</div>
							<div class="tableCell" style="width:100px;text-align: left;">
								{{item.goodsName}}
							</div>
							<div class="tableCell" style="width:110px;">
								{{item.skuValue}}
								{{item.count}}{{item.unit}}
								{{item.goodsDosage}}{{item.outUnit}}
							</div>
							<div class="tableCell" style="width:120px;">
								<span v-if="!$public.isNull(item.goodsUsage)"></span>
								<span v-else>
									外敷 1天2次 3片/次
									<!-- {{item.goodsUsage[0]}} {{item.goodsUsage[1]}}天{{item.goodsUsage[2]}}次 {{item.goodsUsage[3]}}{{item.goodsUsage[4]}}/次 -->
								</span>
							</div>
						</div>
						<div class="subtotal">
							<div>
								小计：
								{{item.totalMoney}}元
							</div>
							<div>
								<span style="display: inline-block;width:16px;height: 16px;line-height: 16px;font-size: 12px;background-color:rgba(94, 123, 250, 1);border-radius: 1px;color:#fff;text-align: center;">荐</span>
								{{detail.useCount>0?$public.chu(item.goodsUseCount*100,detail.useCount):0}}%的医生选择
								<div class="addBtn" @click="add([item])">添加</div>
							</div>
						</div>
					</div>
				</div>
				<div class="totalMoney" v-if="!$public.isNull(detail)">
					总计：￥{{detail.totalMoney}}
				</div>
				<div style="font-size: 12px;color:#98989F;line-height: 16px;padding-bottom:10px;">
					注：评判医生使用标准，只要该药方用药不低于70%的选择，则该用例案例属于被选择
				</div>
			</div>
			<div class="tit">可能会引发的并发症</div>
			<div class="msgBox" v-if="$public.isNull(bingfazhengList)">
				<div style="font-size: 12px;line-height: 40px;text-align: center;">无并发症</div>
			</div>
			<div class="msgBox" v-else>
				<div class="msgLine" v-for="(item,index) in bingfazhengList" :key="index">
					<div class="msgItem">{{index+1}}.{{item}}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				// 标签
				curTag:0,
				tagList:[],
				
				curNavIndex:0,
				
				detail:null,
				
				// 并发症
				bingfazhengList:[],
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.yiliaoxin.userInfo
			},
			curPetInfo(){
				let obj = this.$store.getters["yiliaoxin/curPetInfo"]
				return obj
			},
		},
		props:{
			blItem:{
				default:()=>{
					return {}
				}
			},
			diagnosisTags:{
				default:()=>{
					return []
				}
			}
		},
		watch:{
			diagnosisTags(n,o){
				if(!this.$public.isNull(n)){
					if(JSON.stringify(n)!==JSON.stringify(o)){
						this.getSmartRecipe()
						this.getBingfazhengList();
					}
				}
			}
		},
		mounted(){
			if(!this.$public.isNull(this.diagnosisTags)){
				this.getSmartRecipe()
				this.getBingfazhengList();
			}
			
		},
		methods: {
			changeCurTag(item,index){
				this.curTag=index;
				this.getSmartRecipe()
			},
			changeCurNavIndex(i){
				this.curNavIndex=i;
				this.getSmartRecipe()
			},
			getSmartRecipe(){
				if(this.$public.isNull(this.curPetInfo._id)){
					return
				}
				let params = {
					"petType": this.curPetInfo.apply_type.value,
					"type":this.curNavIndex+1,  // 1治疗效果最好；2治疗时间最快；3性价比高
					"illnessState": this.diagnosisTags[this.curTag],
				}
				let loading = this.$loading()
				this.$http.post('/api/Case/SmartRecipe/Get', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.detail = res.data
					}
				})
			},
			getBingfazhengList(){
				let params = {
					"petId": this.blItem.petId,
					"illnessState": this.diagnosisTags,
				}
				let loading = this.$loading()
				this.$http.post('/api/Case/Complication/List', params).then(res => {
					loading.close();
					if (res.code == 0) {
						let showArr = res.data.map(item=>{
							let arr = [];
							item.complication.map(one=>{
								one.symptom.map(two=>{
									arr.push(one.value+"-"+two.value+"-"+two.symptomLevel.value)
								})
							})
							return arr
						})
						this.bingfazhengList = showArr
					}
				})
			},
			add(arr){
				let list = []
				let loading = this.$loading()
				for(let i=0;i<arr.length;i++){
					let params = {
						"id": arr[i].goodsId,
					}
					this.$http.get(process.env.VUE_APP_Url2+'api/product/medical', params).then(res => {
						res.data.smartRecipeId = this.detail.id
						list.push(res.data)
						if(list.length===arr.length){
							loading.close()
							this.$emit("submit",list)
						}
					})
				}
				
			},
		},
	}
</script>
<style scoped lang="scss">
	.bingliComp{
		margin:0 8px;
		.nav{
			display: flex;margin-bottom:12px;
			.navItem{
				font-size: 11px;color:#73737B;background-color: #F6F7FA;border-radius: 12px;line-height: 22px;border: 1px solid #F6F7FA;margin-left: 8px;width:90px;text-align: center;cursor: pointer;
				&.active{
					color:#5E7BFA;background-color: #F3F8FF;border-color:#5E7BFA;
				}
			}
		}
		.con{
			background-color: #F3F6FF;border:1px solid #E4E7F8;border-radius: 4px;padding:8px;
			.tit{
				font-size: 14px;color:$fontColor;font-weight: bold;padding:10px 0;margin-top:10px;
			}
			.msgBox{
				border:1px solid #D6DCF6;background-color: #fff;border-radius: 3px;padding:0 8px;
				.msgLine{
					display: flex;border-bottom: 1px solid #CBD2FE;font-size: 12px;color:#73737B;line-height: 30px;
					.msgItem{
						width:100%;
					}
					&:last-child{
						border:0;
					}
				}
			}
			.addLine{
				display: flex;justify-content: space-between;padding:16px 0 8px;
				.addLineLabel{
					
				}
				.addAllBtn{
					font-size: 12px;color:#5E7BFA;cursor: pointer;
				}
			}
			.nav1{
				display: flex;
				.nav1Item{
					font-size: 14px;color:rgba(94, 123, 250, 0.5);border-radius: 12px;line-height: 36px;border: 1px solid rgba(94, 123, 250, 0.5);margin-left: 8px;width:100px;text-align: center;border-radius: 6px 6px 0 0;cursor: pointer;
					&.active{
						color:rgba(94, 123, 250, 1);background-color: #F3F8FF;border-color:rgba(94, 123, 250, 1);
					}
				}
			}
			.table{
				border:1px solid #D6DCF6;border-radius: 3px;background-color: #fff;padding:0 8px;margin-top:-1px;position: relative;z-index: 1;
				.row{
					display: flex;border-bottom:1px solid #CBD2FE;padding:10px 0;
					.tableTit{
						font-size: 12px;color:#73737B;text-align: center;
					}
					.tableCell{
						font-size: 12px;color:#333336;text-align: center;
					}
				}
				.subtotal{
					border-bottom:1px solid #CBD2FE;font-size: 12px;display: flex;justify-content: space-between;padding:10px 0;
					.addBtn{
						display: inline-block;width:40px;line-height: 22px;text-align: center;font-size: 12px;color:#fff;background-color:#5E7BFA;border-radius: 4px;cursor: pointer;margin-left: 10px;
					}
					&:last-child{
						border: 0;
					}
				}
			}
			.totalMoney{
				text-align: right;font-size: 12px;color:$fontColor;padding:10px 0;
			}
		}
	}
</style>
